import { PlansPurchase as PlansPurchaseView } from './plans-purchase';
import { PlansPurchaseProvider } from './plans-purchase.provider';

export const PlansPurchase = () => (
   <PlansPurchaseProvider>
      <PlansPurchaseView />
   </PlansPurchaseProvider>
);

export const FeaturePlansPurchase = PlansPurchase;
